export enum EnvironmentNames {
  CNCF = 'cncf',
  EME = 'eme',
  IGF = 'igf',
  SWISS = 'swiss',
  GLF = 'glf',
  SINNGEBER = 'sinngeber',
  TOL = 'tol',
}
